import { Injectable } from '@angular/core';
import { isDefined, isDefinedAndFilledArray } from '../../../../shared/utility/verify.lib';
import { cloneDeep } from 'lodash';
import { ILanguageText } from '../../../../models/language/language-text.model';

@Injectable({
  providedIn: 'root'
})
export class LanguageListHelperService {

  constructor() { }

  public getSelectedLanguageTextsFromRecord(selectedSortedIds: string[], languagesList: ILanguageText[]): ILanguageText[] {
    const newListOfSelectedLanguages: ILanguageText[] = [];

    if (isDefinedAndFilledArray(() => languagesList) && isDefinedAndFilledArray(() => selectedSortedIds)) {
      selectedSortedIds.forEach((foundId: string) => {
        const language: ILanguageText = languagesList.find((entry: ILanguageText) => entry.languageId === foundId);
        if (isDefined(() => language)) {
          newListOfSelectedLanguages.push(language);
        }
      });
    }

    return newListOfSelectedLanguages;
  }

  public sortLanguageList(languagesList: ILanguageText[], activeLanguageId: string): ILanguageText[] {
    let sortedList: ILanguageText[] = cloneDeep(languagesList);

    if (isDefinedAndFilledArray(() => sortedList)) {
      sortedList = sortedList.sort((a: ILanguageText, b: ILanguageText) => {
        let returnValue: number = 0;

        if ([a.languageId, b.languageId].includes(activeLanguageId)) {
            returnValue = b.languageId == activeLanguageId ? 1 : -1;
        } else if (
          b.languageId === 'EN' ||
          (a.languageId !== 'EN' && a.text > b.text)
        ) {
          returnValue = 1;
        } else if (a.languageId === 'EN' || a.text < b.text) {
          returnValue = -1;
        }

        return returnValue;
      });
    }

    return sortedList;
  }

  public filterLanguagesWithSearch(
    languageTexts: ILanguageText[],
    searchText: string
  ): ILanguageText[] {
    let returnValue = cloneDeep(languageTexts);

    if (isDefinedAndFilledArray(() => languageTexts)) {
      returnValue = languageTexts.filter((ILanguageText: ILanguageText) =>
        ILanguageText.text
          .toLowerCase()
          .startsWith(searchText.toLocaleLowerCase())
      );
    }
    return returnValue;
  }

  public sortByAlreadySelectedLanguages(isLanguageSelected: Record<string, boolean>, sortedOldSelectedIds: string[]): string[] {
    const selectedUnsortedIds: string[] = Object.keys(isLanguageSelected).filter(
      (id: string) => isLanguageSelected[id]
    );
    const newLanguagesIds: string[] = sortedOldSelectedIds.filter((entryId: string) => selectedUnsortedIds.includes(entryId));
    const missingIds: string[] = selectedUnsortedIds.filter((entryId) => !newLanguagesIds.includes(entryId));

    return newLanguagesIds.concat(missingIds);
  }
}
